export default __webpack_public_path__ + "static/media/logo.fbed683a.svg";